/*
 * Phedros — Dati di nascita  (v2, 18 settembre 2026)
 *
 * Raccoglie i dati anagrafici sulla scheda prodotto e li allega all'ordine
 * come line item properties (name="properties[_...]").
 *
 * I campi visibili sono di supporto; i valori definitivi vengono composti
 * qui dentro negli input nascosti, agganciati al modulo del carrello
 * tramite l'attributo HTML "form".
 *
 * NOVITA DELLA v2
 *  - tre lingue (it / en / fr) lette dal tema
 *  - luogo di nascita in quattro voci: citta, provincia (sigla), regione, paese
 *  - ora di nascita in tre casi: certa, approssimata, sconosciuta
 *  - data in formato GG/MM/AAAA
 *  - eliminati latitudine, longitudine e fuso orario
 *  - sei registri: coppia, attrazione, ex, famiglia, lavoro, amicizia
 *
 * NOVITA DELLA v2.1 (21 settembre 2026)
 *  - cognome obbligatorio per la sola Persona 1 (chi richiede il documento)
 *  - nel gruppo Amicizia la seconda voce diventa «Ex amico / Ex amica»
 *
 * REGOLA FERMA: cio che l'utente VEDE e tradotto, cio che viene SALVATO no.
 * _TipoRapporto e _Registro viaggiano sempre in forma italiana, qualunque sia
 * la lingua del cliente, altrimenti sul foglio arriverebbero tre vocabolari
 * diversi. La lingua scelta viaggia a parte, in _Lingua.
 */
(function () {
  'use strict';

  /* ==================================================================
     1. DIZIONARIO DELLE DICITURE
     ================================================================== */
  var T = {
    it: {
      titolo: 'I dati per il tuo documento',
      intro: 'Inserisci qui i dati di nascita: servono a calcolare il documento. Senza questi dati non possiamo elaborarlo.',
      rapportoLabel: 'Che rapporto c’è tra voi?',
      rapportoHint: 'Scegli come descriveresti la seconda persona rispetto a te.',
      scegli: '— Scegli —',
      p1: 'Persona 1 — chi richiede il documento',
      p2: 'Persona 2 — l’altra persona',
      nome: 'Nome',
      cognome: 'Cognome',
      data: 'Data di nascita',
      dataNota: '— giorno / mese / anno',
      gg: 'Giorno', mese: 'Mese', anno: 'Anno',
      ggPh: 'GG', annoPh: 'AAAA',
      mesi: ['Gennaio','Febbraio','Marzo','Aprile','Maggio','Giugno','Luglio','Agosto','Settembre','Ottobre','Novembre','Dicembre'],
      ora: 'Ora di nascita',
      oraHint: 'L’ora esatta rende il risultato più preciso. Se non la conosci o puoi indicarci solo la fascia oraria, scegli l’opzione giusta qui sopra: calcoliamo comunque.',
      oraCerta: 'Conosco l’ora esatta',
      oraApprox: 'So solo all’incirca',
      oraIgnota: 'Non conosco l’ora',
      ore: 'Ore', minuti: 'Minuti',
      approxPh: 'es. tra le 6 e le 8 del mattino, oppure: nel pomeriggio',
      approxHint: 'Scrivi una fascia oraria oppure il momento della giornata: mattina, pomeriggio, sera, notte.',
      citta: 'Città di nascita',
      cittaPh: 'Inizia a scrivere: es. Roma, Parigi…',
      cittaVuota: 'Nessuna città trovata. Controlla l’ortografia.',
      errRapporto: 'Scegli che rapporto c’è tra le due persone.',
      errNome: 'inserisci il nome.',
      errCognome: 'inserisci il cognome.',
      errData: 'inserisci giorno, mese e anno di nascita.',
      errDataNo: 'questa data di nascita non esiste, controlla giorno, mese e anno.',
      errOra: 'scegli ore e minuti di nascita, oppure indica che non conosci l’ora esatta.',
      errApprox: 'scrivi la fascia oraria o il momento della giornata.',
      errCitta: 'scegli la città di nascita dall’elenco che compare mentre scrivi.',
      persona: 'Persona'
    },
    en: {
      titolo: 'Details for your reading',
      intro: 'Enter the birth details here: they are what the reading is calculated from. Without them we cannot prepare it.',
      rapportoLabel: 'What is your relationship?',
      rapportoHint: 'Choose how you would describe the second person in relation to you.',
      scegli: '— Choose —',
      p1: 'Person 1 — who is requesting the reading',
      p2: 'Person 2 — the other person',
      nome: 'First name',
      cognome: 'Last name',
      data: 'Date of birth',
      dataNota: '— day / month / year',
      gg: 'Day', mese: 'Month', anno: 'Year',
      ggPh: 'DD', annoPh: 'YYYY',
      mesi: ['January','February','March','April','May','June','July','August','September','October','November','December'],
      ora: 'Time of birth',
      oraHint: 'An exact time makes the reading more precise. If you do not know it, or can only give a rough window, pick the right option above: we will still calculate it.',
      oraCerta: 'I know the exact time',
      oraApprox: 'I only know roughly',
      oraIgnota: 'I do not know the time',
      ore: 'Hours', minuti: 'Minutes',
      approxPh: 'e.g. between 6 and 8 in the morning, or: in the afternoon',
      approxHint: 'Write a time window or the part of the day: morning, afternoon, evening, night.',
      citta: 'City of birth',
      cittaPh: 'Start typing: e.g. Rome, Paris…',
      cittaVuota: 'No city found. Please check the spelling.',
      errRapporto: 'Choose the relationship between the two people.',
      errNome: 'enter the first name.',
      errCognome: 'enter the last name.',
      errData: 'enter day, month and year of birth.',
      errDataNo: 'this date of birth does not exist, please check day, month and year.',
      errOra: 'choose hours and minutes of birth, or state that you do not know the exact time.',
      errApprox: 'write the time window or the part of the day.',
      errCitta: 'choose the city of birth from the list that appears as you type.',
      persona: 'Person'
    },
    fr: {
      titolo: 'Les données pour votre document',
      intro: 'Indiquez ici les données de naissance : elles servent au calcul du document. Sans elles, nous ne pouvons pas le préparer.',
      rapportoLabel: 'Quelle relation avez-vous ?',
      rapportoHint: 'Choisissez comment vous décririez la seconde personne par rapport à vous.',
      scegli: '— Choisir —',
      p1: 'Personne 1 — qui demande le document',
      p2: 'Personne 2 — l’autre personne',
      nome: 'Prénom',
      cognome: 'Nom',
      data: 'Date de naissance',
      dataNota: '— jour / mois / année',
      gg: 'Jour', mese: 'Mois', anno: 'Année',
      ggPh: 'JJ', annoPh: 'AAAA',
      mesi: ['Janvier','Février','Mars','Avril','Mai','Juin','Juillet','Août','Septembre','Octobre','Novembre','Décembre'],
      ora: 'Heure de naissance',
      oraHint: 'L’heure exacte rend le résultat plus précis. Si vous ne la connaissez pas ou ne pouvez indiquer qu’une plage horaire, choisissez l’option qui convient ci-dessus : nous calculons quand même.',
      oraCerta: 'Je connais l’heure exacte',
      oraApprox: 'Je la connais approximativement',
      oraIgnota: 'Je ne connais pas l’heure',
      ore: 'Heures', minuti: 'Minutes',
      approxPh: 'ex. entre 6 et 8 heures du matin, ou : dans l’après-midi',
      approxHint: 'Indiquez une plage horaire ou le moment de la journée : matin, après-midi, soir, nuit.',
      citta: 'Ville de naissance',
      cittaPh: 'Commencez à écrire : ex. Rome, Paris…',
      cittaVuota: 'Aucune ville trouvée. Vérifiez l’orthographe.',
      errRapporto: 'Choisissez la relation entre les deux personnes.',
      errNome: 'indiquez le prénom.',
      errCognome: 'indiquez le nom.',
      errData: 'indiquez le jour, le mois et l’année de naissance.',
      errDataNo: 'cette date de naissance n’existe pas, vérifiez le jour, le mois et l’année.',
      errOra: 'choisissez les heures et les minutes, ou indiquez que vous ne connaissez pas l’heure exacte.',
      errApprox: 'indiquez la plage horaire ou le moment de la journée.',
      errCitta: 'choisissez la ville de naissance dans la liste qui apparaît pendant la saisie.',
      persona: 'Personne'
    }
  };

  /* ==================================================================
     2. ELENCO CHIUSO DEI TIPI DI RAPPORTO
     v = valore salvato (SEMPRE italiano)  ·  r = registro  ·  en/fr = etichette
     ================================================================== */
  var GRUPPI = [
    { it: 'Coppia',             en: 'Partner',            fr: 'Couple' },
    { it: 'Attrazione',         en: 'Attraction',         fr: 'Attirance' },
    { it: 'Ex',                 en: 'Ex',                 fr: 'Ex' },
    { it: 'Famiglia',           en: 'Family',             fr: 'Famille' },
    { it: 'Famiglia acquisita', en: 'In-laws and step-family', fr: 'Belle-famille' },
    { it: 'Lavoro',             en: 'Work',               fr: 'Travail' },
    { it: 'Amicizia',           en: 'Friendship',         fr: 'Amitié' }
  ];

  var RAPPORTI = [
    { g: 0, r: 'coppia',    v: 'Marito / Moglie',            en: 'Husband / Wife',              fr: 'Mari / Épouse' },
    { g: 0, r: 'coppia',    v: 'Compagno / Compagna',        en: 'Partner',                     fr: 'Compagnon / Compagne' },
    { g: 0, r: 'coppia',    v: 'Fidanzato / Fidanzata',      en: 'Boyfriend / Girlfriend',      fr: 'Fiancé / Fiancée' },
    { g: 0, r: 'coppia',    v: 'Amante',                     en: 'Lover',                       fr: 'Amant / Amante' },

    { g: 1, r: 'attrazione', v: 'Una persona che mi attrae',  en: 'Someone I am drawn to',       fr: 'Une personne qui m’attire' },
    { g: 1, r: 'attrazione', v: 'Frequentazione (non dichiarata)', en: 'Seeing each other (undeclared)', fr: 'Fréquentation (non déclarée)' },

    { g: 2, r: 'ex',        v: 'Ex marito / Ex moglie',      en: 'Ex-husband / Ex-wife',        fr: 'Ex-mari / Ex-épouse' },
    { g: 2, r: 'ex',        v: 'Ex compagno / Ex compagna',  en: 'Ex-partner',                  fr: 'Ex-compagnon / Ex-compagne' },
    { g: 2, r: 'ex',        v: 'Ex fidanzato / Ex fidanzata',en: 'Ex-boyfriend / Ex-girlfriend',fr: 'Ex-fiancé / Ex-fiancée' },
    { g: 2, r: 'ex',        v: 'Ex amante',                  en: 'Former lover',                fr: 'Ancien amant / Ancienne amante' },

    { g: 3, r: 'famiglia',  v: 'Padre',                      en: 'Father',                      fr: 'Père' },
    { g: 3, r: 'famiglia',  v: 'Madre',                      en: 'Mother',                      fr: 'Mère' },
    { g: 3, r: 'famiglia',  v: 'Figlio / Figlia',            en: 'Son / Daughter',              fr: 'Fils / Fille' },
    { g: 3, r: 'famiglia',  v: 'Fratello / Sorella',         en: 'Brother / Sister',            fr: 'Frère / Sœur' },
    { g: 3, r: 'famiglia',  v: 'Nonno / Nonna',              en: 'Grandfather / Grandmother',   fr: 'Grand-père / Grand-mère' },
    { g: 3, r: 'famiglia',  v: 'Zio / Zia',                  en: 'Uncle / Aunt',                fr: 'Oncle / Tante' },
    { g: 3, r: 'famiglia',  v: 'Cugino / Cugina',            en: 'Cousin',                      fr: 'Cousin / Cousine' },
    { g: 3, r: 'famiglia',  v: 'Nipote (di nonni)',          en: 'Grandchild',                  fr: 'Petit-enfant' },
    { g: 3, r: 'famiglia',  v: 'Nipote (di zii)',            en: 'Niece / Nephew',              fr: 'Neveu / Nièce' },

    { g: 4, r: 'famiglia',  v: 'Suocero / Suocera',          en: 'Father-in-law / Mother-in-law', fr: 'Beau-père / Belle-mère' },
    { g: 4, r: 'famiglia',  v: 'Genero / Nuora',             en: 'Son-in-law / Daughter-in-law',  fr: 'Gendre / Belle-fille' },
    { g: 4, r: 'famiglia',  v: 'Cognato / Cognata',          en: 'Brother-in-law / Sister-in-law',fr: 'Beau-frère / Belle-sœur' },
    { g: 4, r: 'famiglia',  v: 'Patrigno / Matrigna',        en: 'Stepfather / Stepmother',     fr: 'Beau-père / Belle-mère (recomposée)' },
    { g: 4, r: 'famiglia',  v: 'Figliastro / Figliastra',    en: 'Stepson / Stepdaughter',      fr: 'Beau-fils / Belle-fille' },
    { g: 4, r: 'famiglia',  v: 'Fratellastro / Sorellastra', en: 'Stepbrother / Stepsister',    fr: 'Demi-frère / Demi-sœur' },

    { g: 5, r: 'lavoro',    v: 'Capo',                       en: 'Manager',                     fr: 'Supérieur hiérarchique' },
    { g: 5, r: 'lavoro',    v: 'Dipendente / Collaboratore', en: 'Employee / Team member',      fr: 'Employé / Collaborateur' },
    { g: 5, r: 'lavoro',    v: 'Collega',                    en: 'Colleague',                   fr: 'Collègue' },
    { g: 5, r: 'lavoro',    v: 'Socio / Socia',              en: 'Business partner',            fr: 'Associé / Associée' },

    { g: 6, r: 'amicizia',  v: 'Amico / Amica',              en: 'Friend',                      fr: 'Ami / Amie' },
    { g: 6, r: 'amicizia',  v: 'Ex amico / Ex amica',         en: 'Former friend',               fr: 'Ancien ami / Ancienne amie' }
  ];

  /* ==================================================================
     3. PROVINCE ITALIANE — nome (da GeoNames) verso sigla
     L'API di geocoding non restituisce la sigla in nessun campo: va
     ricavata qui. I nomi vengono normalizzati prima del confronto, cosi
     «Reggio di Calabria», «Reggio Calabria» e «Provincia di Reggio
     Calabria» finiscono tutti su RC.
     ================================================================== */
  var PROVINCE = {
    'aquila':'AQ','chieti':'CH','pescara':'PE','teramo':'TE','matera':'MT','potenza':'PZ','catanzaro':'CZ','cosenza':'CS','crotone':'KR','reggio calabria':'RC','vibo valentia':'VV','avellino':'AV','benevento':'BN','caserta':'CE','napoli':'NA','salerno':'SA','bologna':'BO','ferrara':'FE','forli cesena':'FC','modena':'MO','parma':'PR','piacenza':'PC','ravenna':'RA','reggio emilia':'RE','rimini':'RN','gorizia':'GO','pordenone':'PN','trieste':'TS','udine':'UD','frosinone':'FR','latina':'LT','rieti':'RI','roma':'RM','viterbo':'VT','genova':'GE','imperia':'IM','spezia':'SP','savona':'SV','bergamo':'BG','brescia':'BS','como':'CO','cremona':'CR','lecco':'LC','lodi':'LO','mantova':'MN','milano':'MI','monza brianza':'MB','pavia':'PV','sondrio':'SO','varese':'VA','ancona':'AN','ascoli piceno':'AP','fermo':'FM','macerata':'MC','pesaro urbino':'PU','campobasso':'CB','isernia':'IS','alessandria':'AL','asti':'AT','biella':'BI','cuneo':'CN','novara':'NO','torino':'TO','verbano cusio ossola':'VB','vercelli':'VC','bari':'BA','barletta andria trani':'BT','brindisi':'BR','foggia':'FG','lecce':'LE','taranto':'TA','cagliari':'CA','nuoro':'NU','oristano':'OR','sassari':'SS','sud sardegna':'SU','agrigento':'AG','caltanissetta':'CL','catania':'CT','enna':'EN','messina':'ME','palermo':'PA','ragusa':'RG','siracusa':'SR','trapani':'TP','arezzo':'AR','firenze':'FI','grosseto':'GR','livorno':'LI','lucca':'LU','massa carrara':'MS','pisa':'PI','pistoia':'PT','prato':'PO','siena':'SI','bolzano':'BZ','trento':'TN','perugia':'PG','terni':'TR','aosta':'AO','belluno':'BL','padova':'PD','rovigo':'RO','treviso':'TV','venezia':'VE','verona':'VR','vicenza':'VI',

    /* varianti e nomi storici che GeoNames usa ancora */
    'valle aosta':'AO','vallee aoste':'AO','aoste':'AO','bozen':'BZ','alto adige':'BZ','sudtirol':'BZ','bolzano bozen':'BZ','south tyrol':'BZ','trentino alto adige':'TN','monza':'MB','monza brianza mb':'MB','verbania':'VB','olbia tempio':'SS','carbonia iglesias':'SU','medio campidano':'SU','ogliastra':'NU','reggio nellemilia':'RE','laquila':'AQ','massa':'MS','florence':'FI','rome':'RM','milan':'MI','naples':'NA','turin':'TO','venice':'VE','genoa':'GE'
  };

  var STOP = { 'di':1, 'della':1, 'dello':1, 'dell':1, 'del':1, 'degli':1, 'delle':1,'nell':1, 'nella':1, 'nel':1, 'e':1, 'd':1, 'l':1, 'la':1, 'il':1,'provincia':1, 'citta':1, 'metropolitana':1, 'libero':1, 'consorzio':1,'comunale':1, 'province':1, 'of':1, 'autonoma':1, 'capitale':1,'regione':1, 'territorio':1 };

  function normalizza(s) {
    if (!s) return '';
    var t = String(s).toLowerCase();
    /* toglie gli accenti senza dipendere da normalize(), che manca su browser vecchi */
    t = t.replace(/[àáâãäå]/g, 'a')
         .replace(/[èéêë]/g, 'e')
         .replace(/[ìíîï]/g, 'i')
         .replace(/[òóôõö]/g, 'o')
         .replace(/[ùúûü]/g, 'u')
         .replace(/[ç]/g, 'c');
    t = t.replace(/[’'`]/g, ' ').replace(/[^a-z0-9]+/g, ' ').trim();
    var parole = t.split(' ').filter(function (w) { return w && !STOP[w]; });
    return parole.join(' ');
  }

  function siglaProvincia(admin2, admin1, countryCode) {
    if (countryCode && countryCode !== 'IT') return '';
    var chiavi = [admin2, admin1];
    for (var i = 0; i < chiavi.length; i++) {
      var k = normalizza(chiavi[i]);
      if (k && PROVINCE[k]) return PROVINCE[k];
    }
    return '';
  }

  /* ==================================================================
     4. GEOCODING
     ================================================================== */
  var GEO_URL = 'https://geocoding-api.open-meteo.com/v1/search';
  var FALLBACK = [
    { name: 'Roma',     admin1: 'Lazio',          admin2: 'Roma',     country: 'Italia', country_code: 'IT' },
    { name: 'Milano',   admin1: 'Lombardia',      admin2: 'Milano',   country: 'Italia', country_code: 'IT' },
    { name: 'Napoli',   admin1: 'Campania',       admin2: 'Napoli',   country: 'Italia', country_code: 'IT' },
    { name: 'Torino',   admin1: 'Piemonte',       admin2: 'Torino',   country: 'Italia', country_code: 'IT' },
    { name: 'Palermo',  admin1: 'Sicilia',        admin2: 'Palermo',  country: 'Italia', country_code: 'IT' },
    { name: 'Bologna',  admin1: 'Emilia-Romagna', admin2: 'Bologna',  country: 'Italia', country_code: 'IT' },
    { name: 'Firenze',  admin1: 'Toscana',        admin2: 'Firenze',  country: 'Italia', country_code: 'IT' },
    { name: 'Bari',     admin1: 'Puglia',         admin2: 'Bari',     country: 'Italia', country_code: 'IT' },
    { name: 'Cagliari', admin1: 'Sardegna',       admin2: 'Cagliari', country: 'Italia', country_code: 'IT' },
    { name: 'Catania',  admin1: 'Sicilia',        admin2: 'Catania',  country: 'Italia', country_code: 'IT' }
  ];

  function dettagli(c) {
    return {
      citta: c.name || '',
      provincia: siglaProvincia(c.admin2, c.admin1, c.country_code),
      regione: c.admin1 || '',
      paese: c.country || ''
    };
  }

  function labelOf(c) {
    var d = dettagli(c);
    var p = [d.citta];
    if (d.provincia) p[0] = d.citta + ' (' + d.provincia + ')';
    if (d.regione && d.regione !== d.citta) p.push(d.regione);
    if (d.paese) p.push(d.paese);
    return p.join(', ');
  }

  function capWords(s) {
    return s.replace(/(^|[\s'\-’])([a-zà-ÿ])/g, function (m, a, b) { return a + b.toUpperCase(); });
  }

  function geoFetch(q, lang) {
    return fetch(GEO_URL + '?name=' + encodeURIComponent(q) + '&count=6&language=' + (lang || 'it') + '&format=json')
      .then(function (r) { return r.json(); })
      .then(function (j) {
        return (j && j.results ? j.results : []).map(function (r) {
          return { name: r.name, admin1: r.admin1, admin2: r.admin2,
                   country: r.country, country_code: r.country_code };
        });
      });
  }

  function fallbackSearch(q) {
    q = q.toLowerCase();
    return FALLBACK.filter(function (c) { return c.name.toLowerCase().indexOf(q) === 0; }).slice(0, 6);
  }

  /* ==================================================================
     5. UTILITA
     ================================================================== */
  function pad2(n) { return (n < 10 ? '0' : '') + n; }

  function dataValida(gg, mm, aaaa) {
    if (!gg || !mm || !aaaa) return false;
    if (gg < 1 || gg > 31) return false;
    if (aaaa < 1900 || aaaa > 2030) return false;
    var d = new Date(Date.UTC(aaaa, mm - 1, gg));
    return d.getUTCDate() === gg && d.getUTCMonth() === mm - 1;
  }

  function testo(el, s) { if (el) el.textContent = s; }
  function ph(el, s) { if (el) el.setAttribute('placeholder', s); }

  /* ==================================================================
     6. INIZIALIZZAZIONE DI UN BLOCCO
     ================================================================== */
  function init(root) {
    if (!root || root.__phdnReady) return;
    root.__phdnReady = true;

    var lang = (root.getAttribute('data-lingua') || 'it').slice(0, 2).toLowerCase();
    if (!T[lang]) lang = 'it';
    var t = T[lang];

    var persone = parseInt(root.getAttribute('data-persone'), 10) === 1 ? 1 : 2;
    var chiediOra = root.getAttribute('data-chiedi-ora') === 'true';
    var chiediRapporto = root.getAttribute('data-chiedi-rapporto') === 'true';

    var selRapporto = root.querySelector('[data-phdn-rapporto]');
    var errBox = root.querySelector('[data-phdn-error]');
    var out = root.querySelector('[data-phdn-out]');

    /* ---- diciture fisse ---- */
    testo(root.querySelector('[data-t="titolo"]'), t.titolo);
    testo(root.querySelector('[data-t="intro"]'), t.intro);
    testo(root.querySelector('[data-t="rapportoLabel"]'), t.rapportoLabel);
    testo(root.querySelector('[data-t="rapportoHint"]'), t.rapportoHint);

    /* ---- menu dei rapporti ---- */
    if (selRapporto) {
      selRapporto.innerHTML = '';
      var vuota = document.createElement('option');
      vuota.value = '';
      vuota.textContent = t.scegli;
      selRapporto.appendChild(vuota);

      GRUPPI.forEach(function (g, gi) {
        var og = document.createElement('optgroup');
        og.label = g[lang] || g.it;
        RAPPORTI.forEach(function (v) {
          if (v.g !== gi) return;
          var o = document.createElement('option');
          o.value = v.v;                       // sempre italiano: e il valore salvato
          o.textContent = lang === 'it' ? v.v : (v[lang] || v.v);
          o.setAttribute('data-registro', v.r);
          og.appendChild(o);
        });
        if (og.children.length) selRapporto.appendChild(og);
      });
    }

    /* ---- stato per persona ---- */
    var persons = [];
    Array.prototype.forEach.call(root.querySelectorAll('[data-phdn-person]'), function (el) {
      var idx = parseInt(el.getAttribute('data-phdn-person'), 10);
      if (idx > persone) { el.hidden = true; return; }

      var p = {
        idx: idx,
        el: el,
        titolo: el.querySelector('[data-t="personTitle"]'),
        nome: el.querySelector('[data-phdn-nome]'),
        cognome: el.querySelector('[data-phdn-cognome]'),
        gg: el.querySelector('[data-phdn-gg]'),
        mm: el.querySelector('[data-phdn-mm]'),
        aaaa: el.querySelector('[data-phdn-aaaa]'),
        oraWrap: el.querySelector('[data-phdn-ora-wrap]'),
        radios: el.querySelectorAll('[data-phdn-oratipo]'),
        boxCerta: el.querySelector('[data-phdn-box-certa]'),
        boxApprox: el.querySelector('[data-phdn-box-approx]'),
        ore: el.querySelector('[data-phdn-ore]'),
        min: el.querySelector('[data-phdn-min]'),
        approx: el.querySelector('[data-phdn-approx]'),
        citta: el.querySelector('[data-phdn-citta]'),
        ac: el.querySelector('[data-phdn-ac]'),
        picked: el.querySelector('[data-phdn-picked]'),
        scelta: null, items: [], deb: null, req: 0
      };

      /* diciture della persona */
      testo(p.titolo, idx === 1 ? t.p1 : t.p2);
      testo(el.querySelector('[data-t="nome"]'), t.nome);
      testo(el.querySelector('[data-t="cognome"]'), t.cognome);
      testo(el.querySelector('[data-t="data"]'), t.data);
      testo(el.querySelector('[data-t="dataNota"]'), t.dataNota);
      testo(el.querySelector('[data-t="gg"]'), t.gg);
      testo(el.querySelector('[data-t="mese"]'), t.mese);
      testo(el.querySelector('[data-t="anno"]'), t.anno);
      testo(el.querySelector('[data-t="ora"]'), t.ora);
      testo(el.querySelector('[data-t="oraHint"]'), t.oraHint);
      testo(el.querySelector('[data-t="oraCerta"]'), t.oraCerta);
      testo(el.querySelector('[data-t="oraApprox"]'), t.oraApprox);
      testo(el.querySelector('[data-t="oraIgnota"]'), t.oraIgnota);
      testo(el.querySelector('[data-t="approxHint"]'), t.approxHint);
      testo(el.querySelector('[data-t="citta"]'), t.citta);
      ph(p.gg, t.ggPh);
      ph(p.aaaa, t.annoPh);
      ph(p.approx, t.approxPh);
      ph(p.citta, t.cittaPh);

      /* mesi tradotti */
      if (p.mm) {
        p.mm.innerHTML = '';
        var m0 = document.createElement('option');
        m0.value = ''; m0.textContent = t.mese;
        p.mm.appendChild(m0);
        for (var m = 1; m <= 12; m++) {
          var om = document.createElement('option');
          om.value = String(m);
          om.textContent = pad2(m) + ' · ' + t.mesi[m - 1];
          p.mm.appendChild(om);
        }
      }

      /* ore 00-23 e minuti 00-59 */
      if (p.ore) {
        p.ore.innerHTML = '';
        var h0 = document.createElement('option'); h0.value = ''; h0.textContent = t.ore;
        p.ore.appendChild(h0);
        for (var h = 0; h <= 23; h++) {
          var oh = document.createElement('option');
          oh.value = pad2(h); oh.textContent = pad2(h);
          p.ore.appendChild(oh);
        }
      }
      if (p.min) {
        p.min.innerHTML = '';
        var n0 = document.createElement('option'); n0.value = ''; n0.textContent = t.minuti;
        p.min.appendChild(n0);
        for (var mi = 0; mi <= 59; mi++) {
          var om2 = document.createElement('option');
          om2.value = pad2(mi); om2.textContent = pad2(mi);
          p.min.appendChild(om2);
        }
      }

      persons.push(p);
    });

    if (persone === 1 && persons[0] && persons[0].titolo) persons[0].titolo.hidden = true;

    if (!chiediRapporto) {
      var rw = root.querySelector('[data-phdn-rapporto-wrap]');
      if (rw) rw.hidden = true;
    }
    if (!chiediOra) {
      persons.forEach(function (p) { if (p.oraWrap) p.oraWrap.hidden = true; });
    }

    function setOut(name, value) {
      var f = out.querySelector('input[name="properties[' + name + ']"]');
      if (f) f.value = value == null ? '' : value;
    }

    function oraTipoDi(p) {
      if (!chiediOra) return '';
      for (var i = 0; i < p.radios.length; i++) {
        if (p.radios[i].checked) return p.radios[i].value;
      }
      return '';
    }

    function mostraBox(p) {
      var tipo = oraTipoDi(p);
      if (p.boxCerta) p.boxCerta.hidden = (tipo !== 'certa');
      if (p.boxApprox) p.boxApprox.hidden = (tipo !== 'approssimata');
    }

    /* ---- autocomplete citta ---- */
    function chiudiAc(p) {
      p.ac.hidden = true;
      p.citta.setAttribute('aria-expanded', 'false');
    }
    function renderAc(p, items) {
      p.items = items || [];
      p.ac.innerHTML = '';
      if (!p.items.length) {
        var e = document.createElement('div');
        e.className = 'phdn__ac-empty';
        e.textContent = t.cittaVuota;
        p.ac.appendChild(e);
        p.ac.hidden = false;
        return;
      }
      p.items.forEach(function (c, i) {
        var d = document.createElement('div');
        d.className = 'phdn__ac-item';
        d.setAttribute('role', 'option');
        var det = dettagli(c);
        var sub = [];
        if (det.provincia) sub.push(det.provincia);
        if (det.regione) sub.push(det.regione);
        if (det.paese) sub.push(det.paese);
        var strong = document.createElement('span');
        strong.textContent = det.citta;
        var small = document.createElement('small');
        small.textContent = sub.join(', ');
        d.appendChild(strong);
        d.appendChild(small);
        d.addEventListener('mousedown', function (ev) { ev.preventDefault(); scegli(p, i); });
        p.ac.appendChild(d);
      });
      p.ac.hidden = false;
      p.citta.setAttribute('aria-expanded', 'true');
    }
    function scegli(p, i) {
      var c = p.items[i];
      if (!c) return;
      p.scelta = c;
      p.citta.value = labelOf(c);
      p.picked.textContent = '✓ ' + labelOf(c);
      chiudiAc(p);
      aggiorna();
    }
    function cerca(p, q) {
      var id = ++p.req;
      geoFetch(q, lang).then(function (items) {
        if (id !== p.req) return;
        if (items.length) { renderAc(p, items); return; }
        var qc = capWords(q);
        if (qc === q) { renderAc(p, fallbackSearch(q)); return; }
        geoFetch(qc, lang).then(function (i2) {
          if (id !== p.req) return;
          renderAc(p, i2.length ? i2 : fallbackSearch(q));
        })['catch'](function () { if (id === p.req) renderAc(p, fallbackSearch(q)); });
      })['catch'](function () { if (id === p.req) renderAc(p, fallbackSearch(q)); });
    }

    persons.forEach(function (p) {
      p.citta.addEventListener('input', function () {
        p.scelta = null;
        p.picked.textContent = '';
        aggiorna();
        var q = p.citta.value.trim();
        if (q.length < 2) { chiudiAc(p); return; }
        if (p.deb) clearTimeout(p.deb);
        p.deb = setTimeout(function () { cerca(p, q); }, 220);
      });
      p.citta.addEventListener('blur', function () { setTimeout(function () { chiudiAc(p); }, 150); });

      Array.prototype.forEach.call(p.radios, function (r) {
        r.addEventListener('change', function () { mostraBox(p); aggiorna(); });
      });
      [p.nome, p.cognome, p.gg, p.mm, p.aaaa, p.ore, p.min, p.approx].forEach(function (el) {
        if (!el) return;
        el.addEventListener('input', aggiorna);
        el.addEventListener('change', aggiorna);
      });
      mostraBox(p);
    });

    if (selRapporto) selRapporto.addEventListener('change', aggiorna);

    /* ---- composizione dei valori in uscita ---- */
    function aggiorna() {
      setOut('_Lingua', lang);

      if (selRapporto && chiediRapporto) {
        var opt = selRapporto.options[selRapporto.selectedIndex];
        setOut('_TipoRapporto', selRapporto.value || '');
        setOut('_Registro', (opt && opt.getAttribute('data-registro')) || '');
      } else {
        setOut('_TipoRapporto', '');
        setOut('_Registro', '');
      }

      persons.forEach(function (p) {
        var n = p.idx;
        setOut('_P' + n + 'Nome', p.nome ? p.nome.value.trim() : '');
        /* il cognome esiste solo per la Persona 1: setOut ignora i campi assenti */
        setOut('_P' + n + 'Cognome', p.cognome ? p.cognome.value.trim() : '');

        var gg = parseInt(p.gg.value, 10);
        var mm = parseInt(p.mm.value, 10);
        var aaaa = parseInt(p.aaaa.value, 10);
        setOut('_P' + n + 'Data', dataValida(gg, mm, aaaa) ? (pad2(gg) + '/' + pad2(mm) + '/' + aaaa) : '');

        var tipo = oraTipoDi(p);
        setOut('_P' + n + 'OraTipo', tipo);
        setOut('_P' + n + 'Ora',
          (tipo === 'certa' && p.ore && p.min && p.ore.value !== '' && p.min.value !== '')
            ? (p.ore.value + ':' + p.min.value) : '');
        setOut('_P' + n + 'OraIndicazione',
          (tipo === 'approssimata' && p.approx) ? p.approx.value.trim() : '');

        var c = p.scelta;
        var d = c ? dettagli(c) : null;
        setOut('_P' + n + 'Citta', d ? d.citta : '');
        setOut('_P' + n + 'Provincia', d ? d.provincia : '');
        setOut('_P' + n + 'Regione', d ? d.regione : '');
        setOut('_P' + n + 'Paese', d ? d.paese : '');
      });
    }

    /* ---- validazione ---- */
    function validazione() {
      var errori = [];

      if (chiediRapporto && selRapporto && !selRapporto.value) errori.push(t.errRapporto);

      persons.forEach(function (p) {
        var et = persons.length > 1 ? (t.persona + ' ' + p.idx + ': ') : '';
        if (!p.nome.value.trim()) errori.push(et + t.errNome);
        if (p.cognome && !p.cognome.value.trim()) errori.push(et + t.errCognome);

        var gg = parseInt(p.gg.value, 10);
        var mm = parseInt(p.mm.value, 10);
        var aaaa = parseInt(p.aaaa.value, 10);
        if (!gg || !mm || !aaaa) errori.push(et + t.errData);
        else if (!dataValida(gg, mm, aaaa)) errori.push(et + t.errDataNo);

        if (chiediOra) {
          var tipo = oraTipoDi(p);
          if (tipo === 'certa') {
            if (!p.ore.value || !p.min.value) errori.push(et + t.errOra);
          } else if (tipo === 'approssimata') {
            if (!p.approx.value.trim()) errori.push(et + t.errApprox);
          } else if (!tipo) {
            errori.push(et + t.errOra);
          }
          /* la citta serve appena c'e un'indicazione d'ora, anche approssimata */
          if (tipo !== 'sconosciuta' && !p.scelta) errori.push(et + t.errCitta);
        }
      });

      return errori;
    }

    function mostraErrori(errori) {
      if (!errori.length) { errBox.hidden = true; errBox.innerHTML = ''; return; }
      var ul = document.createElement('ul');
      errori.forEach(function (e) {
        var li = document.createElement('li');
        li.textContent = e;
        ul.appendChild(li);
      });
      errBox.innerHTML = '';
      errBox.appendChild(ul);
      errBox.hidden = false;
      try { errBox.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
    }

    /* ==================================================================
       7. AGGANCIO AL MODULO DEL CARRELLO
       ================================================================== */

    /* ATTENZIONE: su molti temi (Dawn, Studio e derivati) ci sono DUE form che
       puntano a /cart/add: quello dei pagamenti rateali, che compare per primo
       nel documento, e quello vero. Si distinguono perche solo il secondo
       contiene il pulsante con name="add". */
    function trovaForm() {
      var forms = Array.prototype.slice.call(document.querySelectorAll('form[action*="/cart/add"]'));
      if (!forms.length) return null;
      var i;
      for (i = 0; i < forms.length; i++) {
        if (forms[i].querySelector('[name="add"]')) return forms[i];
      }
      for (i = 0; i < forms.length; i++) {
        if (forms[i].offsetParent !== null) return forms[i];
      }
      return forms[0];
    }

    /* ATTENZIONE: form.id NON restituisce l'id del form quando il form contiene
       un campo chiamato "id" — e Shopify ce lo mette sempre (<input name="id">
       con la variante). L'accesso per nome mette in ombra la proprieta. */
    function idDelForm(form) {
      var id = form.getAttribute('id');
      if (!id) {
        id = 'phdn-cart-form-' + Math.random().toString(36).slice(2, 8);
        form.setAttribute('id', id);
      }
      return id;
    }

    function agganciaForm() {
      var form = trovaForm();
      if (!form) return false;
      var formId = idDelForm(form);

      Array.prototype.forEach.call(out.querySelectorAll('[data-phdn-out-field]'), function (f) {
        f.setAttribute('form', formId);
      });

      var campione = out.querySelector('[data-phdn-out-field]');
      if (campione && campione.form !== form) {
        console.warn('[phedros-dati-nascita] input non agganciati al form del carrello: i dati non verrebbero inviati.');
        return false;
      }

      if (form.__phdnBound) return true;
      form.__phdnBound = true;

      function blocca(ev) {
        aggiorna();
        var errori = validazione();
        if (errori.length) {
          ev.preventDefault();
          ev.stopPropagation();
          if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();
          mostraErrori(errori);
          return false;
        }
        mostraErrori([]);
      }

      form.addEventListener('submit', blocca, true);
      var bottoni = form.querySelectorAll('[type="submit"], [name="add"]');
      Array.prototype.forEach.call(bottoni, function (b) {
        b.addEventListener('click', blocca, true);
      });

      return true;
    }

    aggiorna();
    root.classList.add('phdn--ready');   /* il riquadro compare solo a JS attivo */

    if (!agganciaForm()) {
      var tentativi = 0;
      var tm = setInterval(function () {
        if (agganciaForm() || ++tentativi > 20) clearInterval(tm);
      }, 400);
    }
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('[data-phdn]');
    Array.prototype.forEach.call(nodes, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();